export var colors = {
  black: '#201c17',
  blue: '#046eb1',
  cardinal: '#CA1F40',
  darkGrey: '#525455',
  darkRed: '#972114',
  green: '#008600',
  lightGreen: '#b8e986',
  lightGrey: '#fafafa',
  logoBlue: '#0077bd',
  logoDarkRed: '#cc0b18',
  logoGreen: '#18a035',
  logoOrange: '#f39100',
  midGrey: '#959595',
  midRed: '#b81c0a',
  platinum: '#e4e4e4',
  red: '#da1600',
  silver: '#f3f3f3',
  white: '#fff',
  yellow: '#efd063'
};
export var shadows = {
  lightShadow: '0px 1px 2px rgba(0, 0, 0, 0.22), 0px 0px 1px rgba(0, 0, 0, 0.32)',
  shadow: '0 1px 16px 0 rgba(0, 0, 0, 0.22), 0 0 1px 0 rgba(0, 0, 0, 0.32)'
};
export var typography = {
  primaryFont: '"Montserrat", sans-serif',
  secondaryFont: '"mBank", sans-serif'
};
export var zIndex = {
  zIndexBackdrop: 100,
  zIndexDatePicker: 201,
  zIndexHeaderLogo: 201,
  zIndexMenuMore: 210,
  zIndexModal: 200,
  zIndexModalContainer: 120,
  zIndexProcess: 201,
  zIndexProfileSelector: 200,
  zIndexProfileSelectorOverlay: 120,
  zIndexStripe: 201,
  zIndexToast: 210
};
export default {
  colors: colors,
  shadows: shadows,
  typography: typography,
  zIndex: zIndex
};